import React, { Component } from 'react';
import './LoadingSpinner.css';

class LoadingSpinner extends Component {
  render() {
    return (
      <div className="loader">
        <svg width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M28.78 17.018c-1.39 7.886-8.911 13.152-16.798 11.762C4.096 27.39-1.17 19.869.22 11.982 1.61 4.096 9.131-1.17 17.018.22 24.904 1.61 30.17 9.131 28.78 17.018zm-3.942-.695c1.007-5.711-2.806-11.157-8.516-12.164-5.71-1.007-11.155 2.807-12.162 8.518-1.007 5.71 2.805 11.156 8.515 12.163 5.71 1.007 11.156-2.806 12.163-8.517z" fillRule="evenodd"/></svg>
      </div>
    );
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js